import axios from '@/axios'

export default {
  login(item) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/users/login`, item)
        .then(response => {
          axios.defaults.headers.common.authorization = response.data.token
            ? `${response.data.token}`
            : ''
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  },
  getCurrentUser() {
    return new Promise((resolve, reject) => {
      axios
        .get(`/auth/get-me`, {})
        .then(response => {
          return resolve(response.data)
        })
        .catch(error => {
          return reject(error.response)
        })
    })
  }
}
